import { isValidEmail } from "helpers/validators";

const validate = (values, props) => {
  const errors = {};

  if (!values.firstName) {
    errors.firstName = "Please enter your first name";
  }

  if (!values.lastName) {
    errors.lastName = "Please enter your last name";
  }

  if (!props.user || props.user.isEditor === true) {
    if (!values.email) {
      errors.email = "Please enter your email address";
    } else if (isValidEmail(values.email) === false) {
      errors.email = "Please enter a valid email address";
    }

    if (!values.password) {
      errors.password = "Please enter a password";
    }
  }

  if (!values.image) {
    errors.image = "Please upload an image";
  }

  if (values.team === "-") {
    errors.team = "Please select a valid team";
  }

  if (values.team === "new") {
    if (!values.team_name) {
      errors.team_name = "Please enter a team name";
    }

    if (!values.team_target) {
      errors.team_target = "Please enter a target for your team to aim for";
    }

    if (!values.team_logo) {
      errors.team_logo = "Please upload an image for the team's logo";
    }
  }

  return errors;
};

export default validate;
